<template>
  <div>
      <v-card
    :loading="loading"
    class="mx-auto my-12"
    max-width="374"
  >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>
    <!-- <v-layout class="justify-center"> -->
    <v-img
               style="padding-top:50px;"
                height="250"
                src="@/assets/CoursePreview.jpeg"
                ></v-img>
    <!-- </v-layout> -->
    <v-card-subtitle class="mx-3 text-subtitle-1 caption">
       305 View - 14 days ago
    </v-card-subtitle>
    <v-card-title class="green white--text">Complete introduction to Zulu History
        
    </v-card-title>
    <v-card-text>
    <v-card-subtitle class="caption">
       Reading Time - <v-chip small>15min</v-chip>
    </v-card-subtitle>
    </v-card-text>
    <v-card-text>
      <v-row
        align="center"
        class="mx-0"
      >
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ms-4">
          4.5 (413)
        </div>
      </v-row>

      <div class="my-4 text-subtitle-1 caption">
        Language || Culture
      </div>

      <div>Small plates, salads & sandwiches - an intimate setting with 12 indoor seats plus patio seating.</div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-actions class="mx-3 caption">By John Doe
        <v-spacer></v-spacer><v-chip small>$15</v-chip>
    </v-card-actions>

    <v-card-text>
      <v-chip-group
        v-model="selection"
        active-class="deep-purple accent-4 white--text"
        column
      >
        <v-chip>5:30PM</v-chip>

        <v-chip>7:30PM</v-chip>

        <v-chip>8:00PM</v-chip>

        <v-chip>9:00PM</v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="deep-purple lighten-2"
        text
        @click="reserve"
      >
        Reserve
      </v-btn>
    </v-card-actions>
  </v-card>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'

export default {
    props: ['System','SystemEntities'],
    components: {},
    data() {
        return {

        }
    },
    computed:{

    },
    created(){

    },
    methods:{

    }
}
</script>

<style>

</style>
